import type {
  SendPushToAllRequest,
} from '@/domain/push_notifications/entities/push_notification.entity'
import type { PushNotificationRepository } from '@/domain/push_notifications/repositories/push_notification_repository'
import { PushNotificationsRtkDatasource } from '../datasources/push_notifications_rtk_datasource'

export class PushNotificationRepositoryImpl implements PushNotificationRepository {
  constructor(
    private readonly remote: PushNotificationsRtkDatasource = new PushNotificationsRtkDatasource()
  ) {}

  async sendToUser(
    userId: string,
    content: { title: string; message: string }
  ): Promise<void> {
    await this.remote.sendToUser(userId, content.title, content.message)
  }

  async sendToAll(payload: SendPushToAllRequest): Promise<void> {
    await this.remote.sendToAll(payload)
  }
}

export const pushNotificationRepository = new PushNotificationRepositoryImpl()
